import FASTable from "../../../../../components/Tables/FASTable";
import { useSelector } from "react-redux";
import { Loader } from "../../../../../components/Loader/Loader";
import { useTheme } from "../../../../../Themecontext/Themecontext";
export default function Detail() {
  const { Colourdata } = useSelector((state) => state.ClientLogin);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;

  const { RecAdjDtldata } = useSelector((state) => state.ReceivablePaybleSlice);

  function formatDateToDDMMYYYY(isoString) {
    if (!isoString) return "";

    const dateObj = new Date(isoString);
    if (isNaN(dateObj)) return ""; // Invalid date guard

    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const year = dateObj.getFullYear();

    return `${day}/${month}/${year}`;
  }

  const getRows = RecAdjDtldata?.Detail?.map((label, index) => ({
    // srNumber: index + 1,
    AcName: label.AcName,
    VouNo: label.VouNo,
    VouDate: formatDateToDDMMYYYY(label.VouDate),
    Type: label.TransactionName,
    ChallanNo: label.ChallanNo,
    Amount: label.Amount,
    AdjTransactionName: label.AdjTransactionName,
    AdjVouno: label.AdjVouno,
    AdjVouDate: label.AdjVouDate,
    BalAmount: label.BalAmount,
    CommulativeBal: label.CommulativeBal,
    OsDays: label.OsDays,
    shortFirmName: label.shortFirmName,
    AdjAmount: label.AdjAmount,
  }));

  const getColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    { label: "Vou No", key: "VouNo", align: "center" },
    {
      label: "Ac Name",
      key: "AcName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Vou Date", key: "VouDate", align: "center" },
    {
      label: "Type",
      key: "Type",
      align: "center",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Challan No", key: "ChallanNo", align: "center" },
    { label: "Amount", key: "Amount", format: true, align: "right" },
    {
      label: "Adj Transaction Name",
      key: "AdjTransactionName",
      align: "right",
    },
    { label: "Adj Vouno", key: "AdjVouno", align: "right" },
    { label: "Adj VouDate", key: "AdjVouDate", align: "right" },
    { label: "Adj Amount", key: "AdjAmount", format: true, align: "right" },
    { label: "Balance Amount", key: "BalAmount", format: true, align: "right" },
    {
      label: "Commulative Balance",
      key: "CommulativeBal",
      format: true,
      align: "right",
    },
    { label: "Os Days", key: "OsDays", align: "right" },
    { label: "shortFirm Name", key: "shortFirmName", align: "left" },
  ];

  if (RecAdjDtldata === "no" || RecAdjDtldata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }

  return (
    <div style={{ marginTop: "20px" }}>
      <div
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
        }}
      >
        <div
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
            padding: "14px",
            margin: 0,
          }}
        >
          <h2
            style={{
              fontSize: "18px",
              margin: 0,
              letterSpacing: "1px",
              fontWeight: "600",
            }}
          >
            DETAIL
          </h2>
        </div>
        <FASTable
          data={getRows}
          columns={getColumns}
          externalTotals={RecAdjDtldata?.summary?.[0]}
        />
      </div>
    </div>
  );
}
